import { Splide, SplideSlide } from '@splidejs/react-splide';
import {
  HeaderVanIcon,
  HeaderQuickOrderIcon,
  HeaderClearanceIcon,
  HeaderPriceDropIcon,
  HeaderBrandIcon,
  TrustpilotLogoAndText,
} from 'assets/icons';
import { cefRed } from '../../constants/variables';
import TrustpilotStars from '../trustpilot/trustpilot_stars';

const MarketingBadgesSplide = ({
  deliveryInfoHref,
  quickOrderHref,
  clearanceHref,
  offersHref,
  brandsHref,
  trustpilotHref,
  trustpilotStarRating,
}) => (
  <div className="layout_container_class popular-links marketing-splide__container m-d-none">
    <Splide
      options={{
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 5000,
        pagination: false,
        arrows: true,
      }}
      aria-label="Popular Links Carousel"
      className="marketing_badges marketing-splide fl jc-sb">
      <SplideSlide>
        <a href={deliveryInfoHref} className="item fl jc-c ai-c">
          <HeaderVanIcon
            className="marketing_badges-image next-day mr-8"
            fillColor={cefRed}
          />
          <p className="fl m-0">
            <span className="fw-600 tc-black mr-5">
              Next Day Delivery | Mon - Fri
            </span>
            <span className="tc-secondary"> Free on orders over £50*</span>
          </p>
        </a>
      </SplideSlide>

      <SplideSlide>
        <a href={quickOrderHref} className="item fl jc-c ai-c">
          <HeaderQuickOrderIcon className="marketing_badges-image quick-order mr-4" />
          <span className="fw-600 tc-black">Quick Order</span>
        </a>
      </SplideSlide>

      <SplideSlide>
        <a href={clearanceHref} className="item fl jc-c ai-c">
          <HeaderClearanceIcon className="marketing_badges-image clearance mr-4" />
          <span className="fw-600 tc-black">Clearance</span>
        </a>
      </SplideSlide>

      <SplideSlide>
        <a href={offersHref} className="item fl jc-c ai-c">
          <HeaderPriceDropIcon className="marketing_badges-image mr-4" />
          <span className="fw-600 tc-black">Offers</span>
        </a>
      </SplideSlide>

      <SplideSlide>
        <a href={brandsHref} className="item fl jc-c ai-c">
          <HeaderBrandIcon className="marketing_badges-image mr-4" />
          <span className="fw-600 tc-black">Shop by Brand</span>
        </a>
      </SplideSlide>

      <SplideSlide>
        <a href={trustpilotHref} className="trustpilot-link fl jc-c ai-c">
          <TrustpilotLogoAndText className="trustpilot mr-4" />
          <TrustpilotStars
            starRating={trustpilotStarRating}
            id="trustpilot-desktop"
          />
        </a>
      </SplideSlide>
    </Splide>
  </div>
);

export default MarketingBadgesSplide;
